import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationService } from '@nutrix/util-config';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ButtonModule } from 'primeng/button';

@Component({
  imports: [RouterOutlet, ToastModule, MessageModule, ConfirmDialogModule, ButtonModule],
  selector: 'nutrix-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly startingNavService = inject(NavigationService).history$$.asObservable().subscribe();
}
